/**
 * "Pregunta compartida" badge (Task 192). Shown above the composer when the
 * current draft was prefilled from a shared `?q=` link, so the reader knows the
 * question came from someone else and can edit it before sending.
 *
 * Extracted in Task 203 — it was duplicated verbatim in the idle and dock
 * composer blocks. Render it only when both conditions hold (shared origin AND a
 * pending draft); the caller passes the already-computed visibility.
 */
import type { Strings } from "../strings";

export function SharedBadge(props: { strings: Strings; visible: boolean }): JSX.Element | null {
  if (!props.visible) return null;
  return (
    <div className="shared-badge" role="note">
      {props.strings.sharedQuestionBadge}
    </div>
  );
}
